/* FGM Briggs parts-only brand routing 2026-09-27 */
(function () {
  'use strict';
  function isBriggsBrand(value) {
    var q = String(value || '').toLowerCase().replace(/^vendor\s*:\s*/, '').replace(/[^a-z0-9]+/g, ' ').trim();
    return /^(briggs(?: (?:and )?stratton)?)(?: parts| spare parts)?$/.test(q);
  }
  var destination = '/collections/briggs-stratton';
  if (/^\/search\/?$/.test(location.pathname) && isBriggsBrand(new URLSearchParams(location.search).get('q'))) {
    location.replace(destination);
  }
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = new URL(form.action, location.origin);
    var input = form.querySelector('input[name="q"]:not([type="hidden"])');
    if (/^\/search\/?$/.test(action.pathname) && input && isBriggsBrand(input.value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(destination);
    }
  }, true);
})();

(() => {
  'use strict';

  const BRAND_TAGS = ["collection_brand_al_ko","collection_brand_archer","collection_brand_ariens","collection_brand_atom","collection_brand_ayp","collection_brand_b3c","collection_brand_bolens","collection_brand_briggs_stratton","collection_brand_bushranger","collection_brand_champion","collection_brand_cheetah","collection_brand_cox","collection_brand_craftsman","collection_brand_cub_cadet","collection_brand_deutscher","collection_brand_diamond_edge","collection_brand_dixon","collection_brand_echo","collection_brand_ego","collection_brand_exmark","collection_brand_ferrex","collection_brand_ferris","collection_brand_flymo","collection_brand_forest_armour","collection_brand_fullas","collection_brand_gravely","collection_brand_greenfield","collection_brand_greenworks","collection_brand_hansa","collection_brand_honda","collection_brand_husqvarna","collection_brand_hustler","collection_brand_hydro_gear","collection_brand_jakmax","collection_brand_john_deere","collection_brand_jonsered","collection_brand_kawasaki","collection_brand_kohler","collection_brand_kubota","collection_brand_loncin","collection_brand_makita","collection_brand_mammotion","collection_brand_masport","collection_brand_mcculloch","collection_brand_morrison","collection_brand_mtd","collection_brand_murray","collection_brand_ngk","collection_brand_oregon","collection_brand_poulan","collection_brand_powertech","collection_brand_prokut","collection_brand_rato","collection_brand_redmax","collection_brand_robin","collection_brand_rok","collection_brand_rover","collection_brand_ryobi","collection_brand_sanli","collection_brand_scag","collection_brand_shindaiwa","collection_brand_simplicity","collection_brand_snapper","collection_brand_solo","collection_brand_spartan","collection_brand_stens","collection_brand_stiga","collection_brand_stihl","collection_brand_subaru","collection_brand_supaswift","collection_brand_surecan","collection_brand_talon","collection_brand_tanaka","collection_brand_tecomec","collection_brand_tecumseh","collection_brand_toro","collection_brand_trail_blazer","collection_brand_tuff_torq","collection_brand_victa","collection_brand_wacker_neuson","collection_brand_walbro","collection_brand_warner","collection_brand_weedwakka","collection_brand_yard_king","collection_brand_yardpro"];
  const TYPE_NAMES = ["Air Conductor","Air Filter","Air Filter Case","Air Guide","Anti Sway Bar","Anti Vibration Mount","Anti-Vibration Buffer","Arborist Equipment","Armrest","Automower Installation Kit","Axle","Bar & Chain Kit","Bar & Chain Oil","Battery","Battery Charger","Bearing","Belt Guide","Blade Adapter","Blade Clutch","Blade Disc","Blade Holder","Blower Accessories","Blower Tube","Boundary Wire","Boundary Wire Staples","Bracket","Brake Arm","Brake Assembly","Brake Cable","Breather Assembly","Breather Tube","Brushcutter Harness","Bushing","Cable Lock","Camshaft","Cap","Carburetor","Carburetor Insulator","Carburetor Jet","Carburetor Repair Kit","Cassette","Chain Brake","Chain Brake Band","Chain Tensioner","Chainsaw Bar Plate","Chainsaw Carrying Bag","Chainsaw Chain","Chainsaw Guide Bar","Chainsaw Transport Tray","Charging Coil","Charging Station","Choke","Choke Cable","Choke Control","Clamping Sleeve","Cleaning & Maintenance Kit","Cleaning Spray","Clutch","Clutch Cable","Clutch Drum","Connecting Rod","Connector","Control Cable","Control Plate","Cooling Fan","Cover","Crankcase","Crankshaft","Cutting Deck Assembly","Cylinder","Cylinder & Piston Kit","Cylinder Head","Decal","Deck Baffle","Deck Engagement Cable","Deck Linkage","Deck Rebuild Kit","Deck Roller","Deck Shell","Desiccant","Diamond Cutting Blade","Discharge Chute","Drive Belt","Drive Cone","Edger Blade","Emblem","Engine","Engine Oil","Engine Part","Fan & Impeller","Fastener","Felling Lever","Felling Spike","Filter","Flange","Flywheel","Frame","Fuel Cap","Fuel Container","Fuel Filter","Fuel Gauge","Fuel Hose","Fuel Pump","Fuel Spout","Fuel Tank","Gasket","Gasket Set","Gear","Gearbox & Transmission","Generator Inverter","Generator Parallel Cable","Generator Socket","Governor Assembly","Grass Catcher","Grass Catcher Frame","Ground Support","Guard","HOUSING","Handle","Hedge Trimmer Attachment","Hedge Trimmer Blade","Hedge Trimmer Cutting Assembly","Height Adjustment Arm","Honda Generator Mat","Hose","Hose Nipple","Hour Meter","Hydraulic Oil","Hydraulic Oil Service Kit","Idler Pulley","Ignition Coil","Ignition Key","Ignition Switch","Intake Boot","Intake Clamp","Intake Manifold","Lawn Mower Blade","Lever","Lifting Hook","Lifting Tongs","Light Kit","Loading Ramp","Log Horse","Lubricant","Mower Chassis","Muffler","Muffler Deflector","Mug","Mulch Plug","Mulching Kit","O-Ring","Oil Cap & Dipstick","Oil Drain Plug","Oil Filter","Oil Plug","Oil Pump","Oil Seal","Oil Spout","Piston","Power Inverter","Price Adjustment","Primer Bulb","Protective Equipment","Pruning Saw","Pulley","Push Rod","Recoil Starter","Robotic Mower Garage","Rubber Isolator","Seal","Seat","Sensor","Service Kit","Service Tool","Shaft","Shaft Joint","Shaft Joint Housing","Sharpening Tool","Shift Plate","Short Block","Solar Panel","Solenoid","Spark Arrester","Spark Plug","Spark Plug Cap","Spike","Spindle Assembly","Spring","Sprocket","Starter Motor","Starter Repair Part","Starter Rope","Steering Drag Link","Switch","Thermostat","Throttle Cable","Throttle Control","Throttle Lockout","Toy","Trigger","Trimmer Head","Trimmer Line","Tyre & Tube","Vacuum Bag","Vacuum Dust Bag","Valve","Voltage Regulator","Wheel","Wheel Bearing","Wiring Coupler","Wiring Harness"];
  const SEARCH_PATH = '/search';
  const ORIGINAL_PARAM = 'fgm_original_q';
  const STORE_PREFIX = 'fgm-search-original:';
  const SEARCH_SYNTAX = /\b(?:tag|title|body|vendor|product_type|sku)\s*:|\b(?:AND|OR|NOT)\b/i;
  const MACHINE_NOUN = /\b(?:mowers?|lawnmowers?|tractors?|ride\s*ons?|chainsaws?|brushcutters?|trimmers?|blowers?|generators?|pumps?|edgers?|chippers?|pressure\s*washers?)\b/i;
  const BATTERY_NOUN = /\b(?:batter(?:y|ies)|battery\s*packs?)\b/i;
  const PART_NOUN = /\b(?:parts?|blades?|filters?|oil|service\s*kits?|tune\s*up\s*kits?|repair\s*kits?|catchers?|bags?|frames?|spindles?|pulleys?|belts?|carburett?ors?|starters?|gaskets?|coils?|spark\s*plugs?|sparkplugs?|chains?|decks?|chutes?|mufflers?|decals?|clutches?|fasteners?|wheels?|covers?|guards?|switches?|cables?|bearings?|seals?|springs?|hoses?|valves?|sprockets?|shafts?|axles?|crankshafts?|pistons?|cylinders?|brackets?|levers?|harnesses?|caps?|dipsticks?|gears?|gearbox(?:es)?|transmissions?|impellers?|arbors?|adapters?|keys?|gauges?|primers?|mounts?|baffles?|tyres?|tires?|tubes?|bushings?|lubricants?|sensors?|thermostats?|connectors?|solenoids?|flywheels?|crankcases?|triggers?|emblems?|flanges?|chokes?|trimmer\s*line|trimmer\s*head|guide\s*bar|chain\s*brake|fuel\s*tank|fuel\s*pump|oil\s*pump|air\s*cleaner|grass\s*catcher|mulch\s*plug|mulching\s*kit|installation\s*kit|spare\s*parts?|replacement\s*parts?|accessor(?:y|ies)|attachments?|chargers?)\b/i;

  const normalize = value => value.toLowerCase().normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  const singular = word => {
    if (word === 'batteries') return 'battery';
    if (word === 'pulleys') return 'pulley';
    if (word === 'tyres' || word === 'tires') return 'tyre';
    if (word.endsWith('ies') && word.length > 4) return `${word.slice(0, -3)}y`;
    if (word.endsWith('es') && /(ches|shes|xes|sses)$/.test(word)) return word.slice(0, -2);
    if (word.endsWith('s') && !word.endsWith('ss') && word.length > 3) return word.slice(0, -1);
    return word;
  };
  const canon = value => normalize(value).split(' ').filter(Boolean).map(singular).join(' ');
  const brands = BRAND_TAGS.map(tag => ({tag, name:tag.slice('collection_brand_'.length).replace(/_/g, ' ')}))
    .sort((a, b) => b.name.length - a.name.length);
  const typeNames = [...new Set(TYPE_NAMES)];
  const aliases = new Map();
  const skipSingle = new Set(['part', 'assembly', 'equipment', 'tool']);
  for (const name of typeNames) {
    const words = canon(name).split(' ');
    for (let start = 0; start < words.length; start++) {
      const phrase = words.slice(start).join(' ');
      if (words.length - start === 1 && skipSingle.has(phrase)) continue;
      if (!aliases.has(phrase)) aliases.set(phrase, []);
      aliases.get(phrase).push(name);
    }
  }
  aliases.set('catcher bag', ['Grass Catcher']);
  aliases.set('catcher', ['Grass Catcher', 'Grass Catcher Frame']);
  aliases.set('air cleaner', ['Air Filter']);
  aliases.set('gearbox', ['Gearbox & Transmission']);
  // Complete engines are classified as Parts while keeping their Engines product type.
  aliases.set('engine', ['Engine', 'Engines']);
  aliases.set('tyre', ['Tyre & Tube']);
  aliases.set('tire', ['Tyre & Tube']);
  aliases.set('carburettor', ['Carburetor']);
  aliases.set('sparkplug', ['Spark Plug']);
  const sortedAliases = [...aliases.keys()].sort((a, b) => b.split(' ').length - a.split(' ').length || b.length - a.length);

  function isPartSearch(query) {
    if (SEARCH_SYNTAX.test(query)) return false;
    const words = normalize(query);
    if (!words) return false;
    if (PART_NOUN.test(words)) return true;
    if (BATTERY_NOUN.test(words) && MACHINE_NOUN.test(words)) return false;
    if (BATTERY_NOUN.test(words)) return true;
    const normalized = ` ${canon(query)} `;
    return sortedAliases.some(alias => normalized.includes(` ${alias} `));
  }

  function matchingBrands(query) {
    const words = ` ${normalize(query)} `;
    return brands.filter(brand => words.includes(` ${brand.name} `));
  }

  function removeBrand(query, brand) {
    const words = brand.name.split(' ').map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    return query.replace(new RegExp(`\\b${words.join('[^a-z0-9]+')}\\b`, 'i'), ' ');
  }

  function categoryFor(query) {const beltPhrase=/\btransmission\s+belts?\b/i.exec(query);if(beltPhrase)return{alias:"belt",types:["Drive Belt"],start:beltPhrase.index+ beltPhrase[0].lastIndexOf(" ")+1,end:beltPhrase.index+beltPhrase[0].length};
    const tokens = [...query.matchAll(/[a-z0-9]+/gi)].map(match => ({word:singular(match[0].toLowerCase()), start:match.index, end:match.index + match[0].length}));
    const words = tokens.map(token => token.word);
    for (const alias of sortedAliases) {
      const target = alias.split(' ');
      for (let i = 0; i <= words.length - target.length; i++) {
        if (!target.every((word, j) => word === words[i + j])) continue;
        return {alias, types:aliases.get(alias), start:tokens[i].start, end:tokens[i + target.length - 1].end};
      }
    }
    return null;
  }

  const typeTerm = name => `product_type:"${name.replace(/"/g, '\\"')}"`;
  const typeGroup = names => {
    const terms = [...new Set(names)].map(typeTerm);
    return terms.length > 1 ? `(${terms.join(' OR ')})` : terms[0];
  };
  function categoryTerm(category) {
    if (category.alias === 'blade') {
      const blades = typeNames.filter(name => canon(name).endsWith(' blade'));
      const group = [...blades.map(typeTerm), '(product_type:Fastener title:blades)', '(product_type:"Blade Disc" title:combo)'];
      return `(${group.join(' OR ')}) -title:control -title:washer -title:"bolt set"`;
    }
    const group = typeGroup(category.types);
    if (category.alias.endsWith(' blade')) return `${group} -title:control`;
    const head = category.alias.split(' ').at(-1);
    if (head === 'filter' || category.alias === 'air cleaner')
      return `${group} title:filter -title:cover -title:case -title:housing -title:holder -title:starter`;
    if (category.alias === 'battery')
      return `${group} title:battery -title:charger -title:case -title:box -title:attachment -title:head`;
    if (category.alias === 'oil')
      return `${group} title:oil -title:filter -title:seal -title:pump -title:cap -title:plug`;
    if (category.alias === 'catcher bag' || category.alias === 'catcher') return `${group} title:catcher`;
    if (category.alias === 'service kit') return `${group} title:kit`;
    if (category.alias === 'gearbox') return `${group} (title:gearbox OR title:transmission)`;
    if (category.alias === 'tyre' || category.alias === 'tire') return `${group} (title:tyre OR title:tire)`;
    if (category.alias === 'carburettor') return `${group} title:carburetor`;
    return `${group} title:${head}`;
  }

  function build(query, options = {}) {
    const original = String(query || '').trim().replace(/\s+/g, ' ');
    if (!original || (!options.forceParts && !isPartSearch(original))) return null;
    if (SEARCH_SYNTAX.test(original) && !options.forceParts) return null;

    // Correct this common transposition before matching the catalogue brand tag.
    let remaining = original.replace(/\bsacg\b/gi, 'scag');
    let brandTags = options.brandTag ? [options.brandTag] : [];
    if (!brandTags.length) {
      for (const brand of matchingBrands(remaining)) {
        brandTags.push(brand.tag);
        remaining = removeBrand(remaining, brand);
      }
    }
    brandTags = [...new Set(brandTags)];
    const brandQuery = brandTags.length > 1
      ? `(${brandTags.map(tag => `tag:${tag}`).join(' OR ')})`
      : brandTags.length ? `tag:${brandTags[0]}` : '';
    // A complete engine is a Parts item with its own catalogue tag. Keep oil,
    // filters and other engine accessories on their specific parts searches.
    const engineIntent = /\bengines?\b/i.test(remaining) &&
      !/\b(?:oil|filter|cover|spark\s*plug|carburett?or|gasket|kit|coil|cap|starter|seal|pump|hose|clutch|bolt|screw|shaft|decal)\b/i.test(remaining);
    if (engineIntent) {
      const model = remaining.replace(/\bengines?\b/gi, ' ').replace(/\bparts?\b/gi, ' ').replace(/\s+/g, ' ').trim();
      return {
        original,
        query: ['tag:catalog_engine', brandQuery, model].filter(Boolean).join(' '),
        category: 'engine',
      };
    }
    const category = categoryFor(remaining);
    let categoryQuery = '';
    if (category) {
      categoryQuery = categoryTerm(category);
      remaining = `${remaining.slice(0, category.start)} ${remaining.slice(category.end)}`;
    }
    // 'parts' describes the catalogue, not a word required in each product title.
    remaining = remaining.replace(/\b(?:(?:spare|replacement)\s+)?parts?\b/gi, ' ').replace(/\s+/g, ' ').trim(); remaining = remaining.split(' ').map(word => /^[a-z0-9][a-z0-9.-]*$/i.test(word) && /\d{3}/.test(word) ? JSON.stringify(word) : word).join(' ');
    return {
      original,
      query: ['tag:catalog_parts', brandQuery, categoryQuery, remaining].filter(Boolean).join(' '),
      category: category?.alias || null,
    };
  }

  function remember(result) {
    try { sessionStorage.setItem(STORE_PREFIX + result.query, result.original); } catch (_) { /* Storage is optional. */ }
  }

  function searchUrl(result) {
    const url = new URL(SEARCH_PATH, location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', result.query);
    url.searchParams.set(ORIGINAL_PARAM, result.original);
    return url;
  }

  function showOriginal(query, original) {
    if (!original || !query || original === query) return;
    document.querySelectorAll('form[action*="/search"] input[name="q"]:not([type="hidden"])')
      .forEach(input => { input.value = original; });
    document.title = document.title.replace(query, original);
    document.querySelectorAll('.template-search__header [role="status"], #ProductCountDesktop, #ProductCount')
      .forEach(element => { element.textContent = element.textContent.replace(query, original); });
  }

  function onSearchPage() {
    if (location.pathname.replace(/\/$/, '') !== SEARCH_PATH) return;
    const params = new URL(location.href).searchParams;
    const query = params.get('q') || '';
    // Older storefront links used a parts tag with a free-text category. Upgrade those links too.
    const legacy = query.match(/^tag:catalog_parts(?:\s+tag:(collection_brand_[a-z0-9_]+))?\s+(.+)$/i);
    if (legacy && (!legacy[1] || BRAND_TAGS.includes(legacy[1])) && !SEARCH_SYNTAX.test(legacy[2])) {
      const precise = build(legacy[2], {forceParts:true, brandTag:legacy[1] || ''});
      if (precise?.category) {
        let previous = params.get(ORIGINAL_PARAM);
        if (!previous) {
          try { previous = sessionStorage.getItem(STORE_PREFIX + query); } catch (_) { /* Storage is optional. */ }
        }
        const brandName = legacy[1]?.slice('collection_brand_'.length).replace(/_/g, ' ') || '';
        precise.original = previous || [brandName, legacy[2]].filter(Boolean).join(' ');
        remember(precise);
        location.replace(searchUrl(precise).href);
        return;
      }
    }
    const result = build(query);
    if (result) {
      remember(result);
      location.replace(searchUrl(result).href);
      return;
    }
    let original = params.get(ORIGINAL_PARAM);
    if (!original) {
      try { original = sessionStorage.getItem(STORE_PREFIX + query); } catch (_) { /* Storage is optional. */ }
    }
    showOriginal(query, original);
  }

  window.FGMSearchIntent = {build, isPartSearch, remember, searchUrl, matchingBrands, removeBrand};

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-fgm-parts-search')) return;
    let action;
    try { action = new URL(form.action, location.origin); } catch (_) { return; }
    if (action.pathname.replace(/\/$/, '') !== SEARCH_PATH) return;
    const input = form.querySelector('input[name="q"]:not([type="hidden"])');
    const result = input && build(input.value);
    if (!result) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    remember(result);
    location.assign(searchUrl(result).href);
  }, true);

  document.addEventListener('input', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
    const predictive = input.closest('predictive-search');
    if (!predictive || !isPartSearch(input.value)) return;
    predictive.close?.(true);
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('focus', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
    const predictive = input.closest('predictive-search');
    if (!predictive || !isPartSearch(input.value)) return;
    predictive.close?.(true);
    event.stopImmediatePropagation();
  }, true);

  onSearchPage();
})();

